import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Server-validated promo code state + actions for a given SKU.
export default function usePromo(sku = "PUBLISH") {
  const [promo, setPromo] = useState(null); // {code, percent_off, final_amount, list_amount} | null
  const [promoInput, setPromoInput] = useState("");
  const [promoBusy, setPromoBusy] = useState(false);
  const [promoErr, setPromoErr] = useState("");

  const applyPromo = async () => {
    const code = promoInput.trim().toUpperCase();
    if (!code) return;
    setPromoBusy(true);
    setPromoErr("");
    try {
      const { data } = await api.get(`/promo/validate`, { params: { code, sku } });
      if (data.valid) {
        setPromo(data);
        toast.success(`${data.percent_off}% off applied → $${data.final_amount}`);
      } else {
        setPromo(null);
        setPromoErr("Invalid or expired code");
      }
    } catch (e) {
      setPromo(null);
      setPromoErr(
        e?.response?.status === 429
          ? "Too many attempts — wait a minute and retry"
          : "Invalid or expired code"
      );
    } finally {
      setPromoBusy(false);
    }
  };

  const clearPromo = () => {
    setPromo(null);
    setPromoInput("");
    setPromoErr("");
  };

  return { promo, promoInput, setPromoInput, promoBusy, promoErr, applyPromo, clearPromo };
}
